export const UPLOAD_PROGRESS = {
  CIRCLE: {
    RADIUS: 23,
    OUTER_STROKE_WIDTH: 3,
    INNER_STROKE_WIDTH: 3,
    DEFAULT_OUTER_STROKE: '#09c6da',
    INNER_STROKE: '#47665f',
    TITLE: '#ffffff',
    UNITS: '#ffffff',
    TITLE_FONT_SIZE: 10,
    ANIMATION_DURATION: 300,
    BACKGROUND_PADDING: 0,
    SPACE: -3
  }
} as const;
